<template>
  <main
    class="main-content d-flex justify-content-center align-items-start p-4 overflow-auto mt-6"
    style="background-color: #f8f9fa"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-8">
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-body p-4">
              <h5 class="mb-1">Document</h5>
              <p class="text-muted small mb-4">
                Upload all your legal entity documents. Please upload file with
                format: jpg, png, pdf with maximum 2MB.
              </p>

              <!-- Document List -->
              <div class="card mb-3">
                <div
                  class="card-header"
                  style="
                    background-color: #e8f5e9;
                    border-bottom: none;
                    padding: 0.75rem 1rem;
                  "
                >
                  <h6 class="mb-0 font-weight-bold text-dark">
                    Required Documents
                  </h6>
                </div>
                <div class="card-body" style="padding: 1rem">
                  <div
                    class="d-flex justify-content-between align-items-center px-3 input-form-frame"
                  >
                    <div>
                      <label class="mb-0 font-label">
                        Akta Pendirian dan SK Kemenkumham<span
                          class="text-danger"
                          >*</span
                        >
                      </label>
                    </div>
                    <div class="d-flex align-items-center">
                      <template
                        v-if="
                          isUploading &&
                          currentUploadingKey === 'akta_pendirian'
                        "
                      >
                        <LoadingBar
                          :isLoading="isUploading"
                          :progress="uploadProgress"
                          class="me-2"
                        />
                      </template>
                      <template v-if="fileAkta">
                        <div class="d-flex gap-2 align-items-center">
                          <div class="d-flex gap-2">
                            <img
                              src="/assets/icons/ic_success.png"
                              width="24px"
                              height="24px"
                            />
                            <a :href="fileAkta" target="_blank">{{
                              truncateText(fileAkta)
                            }}</a>
                          </div>

                          <img
                            src="../../../public/assets/trash.png"
                            alt="Delete"
                            class="ms-2 trash-icon"
                            @click="deleteFile('fileAkta')"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <input
                          type="file"
                          id="aktaPendirian"
                          class="d-none"
                          @change="handleFile('akta_pendirian', $event)"
                        />
                        <label
                          for="aktaPendirian"
                          class="btn btn-outline-secondary mb-0"
                          >Upload File</label
                        >
                      </template>
                    </div>
                  </div>
                  <span
                    v-if="validationErrors.akta_pendirian"
                    class="text-danger small"
                    >Document cannot be empty</span
                  >
                  <div
                    class="d-flex justify-content-between align-items-center px-3 input-form-frame"
                  >
                    <div>
                      <label class="mb-0 font-label">
                        Surat Izin Operasional yang Berlaku<span
                          class="text-danger"
                          >*</span
                        >
                      </label>
                    </div>
                    <div class="d-flex align-items-center">
                      <template
                        v-if="
                          isUploading &&
                          currentUploadingKey === 'surat_izin_operasional'
                        "
                      >
                        <LoadingBar
                          :isLoading="isUploading"
                          :progress="uploadProgress"
                          class="me-2"
                        />
                      </template>
                      <template v-if="fileSiup">
                        <div class="d-flex gap-2 align-items-center">
                          <div class="d-flex gap-2">
                            <img
                              src="/assets/icons/ic_success.png"
                              width="24px"
                              height="24px"
                            />
                            <a :href="fileSiup" target="_blank">{{
                              truncateText(fileSiup)
                            }}</a>
                          </div>

                          <img
                            src="../../../public/assets/trash.png"
                            alt="Delete"
                            class="ms-2 trash-icon"
                            @click="deleteFile('fileSiup')"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <input
                          type="file"
                          id="suratIzinOperasional"
                          class="d-none"
                          @change="handleFile('surat_izin_operasional', $event)"
                        />
                        <label
                          for="suratIzinOperasional"
                          class="btn btn-outline-secondary mb-0"
                          >Upload File</label
                        >
                      </template>
                    </div>
                  </div>
                  <span
                    v-if="validationErrors.surat_izin_operasional"
                    class="text-danger small"
                    >Document cannot be empty</span
                  >
                  <div
                    class="d-flex justify-content-between align-items-center px-3 input-form-frame"
                  >
                    <div>
                      <label class="mb-0 font-label">
                        Identitas Pribadi Direktur Utama<span
                          class="text-danger"
                          >*</span
                        >
                      </label>
                    </div>
                    <div class="d-flex align-items-center">
                      <template
                        v-if="
                          isUploading &&
                          currentUploadingKey === 'direktur_utama_id'
                        "
                      >
                        <LoadingBar
                          :isLoading="isUploading"
                          :progress="uploadProgress"
                          class="me-2"
                        />
                      </template>
                      <template v-if="fileDirektur">
                        <div class="d-flex gap-2 align-items-center">
                          <div class="d-flex gap-2">
                            <img
                              src="/assets/icons/ic_success.png"
                              width="24px"
                              height="24px"
                            />
                            <a :href="fileDirektur" target="_blank">{{
                              truncateText(fileDirektur)
                            }}</a>
                          </div>

                          <img
                            src="../../../public/assets/trash.png"
                            alt="Delete"
                            class="ms-2 trash-icon"
                            @click="deleteFile('fileDirektur')"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <input
                          type="file"
                          id="direkturUtamaId"
                          class="d-none"
                          @change="handleFile('direktur_utama_id', $event)"
                        />
                        <label
                          for="direkturUtamaId"
                          class="btn btn-outline-secondary mb-0"
                          >Upload File</label
                        >
                      </template>
                    </div>
                  </div>
                  <span
                    v-if="validationErrors.direktur_utama_id"
                    class="text-danger small"
                    >Document cannot be empty</span
                  >
                  <div
                    class="d-flex justify-content-between align-items-center px-3 input-form-frame"
                  >
                    <div>
                      <label class="mb-0 font-label">
                        NIB Perusahaan<span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="d-flex align-items-center">
                      <template
                        v-if="isUploading && currentUploadingKey === 'nib_file'"
                      >
                        <LoadingBar
                          :isLoading="isUploading"
                          :progress="uploadProgress"
                          class="me-2"
                        />
                      </template>
                      <template v-if="filenib">
                        <div class="d-flex gap-2 align-items-center">
                          <div class="d-flex gap-2">
                            <img
                              src="/assets/icons/ic_success.png"
                              width="24px"
                              height="24px"
                            />
                            <a :href="filenib" target="_blank">{{
                              truncateText(filenib)
                            }}</a>
                          </div>

                          <img
                            src="../../../public/assets/trash.png"
                            alt="Delete"
                            class="ms-2 trash-icon"
                            @click="deleteFile('filenib')"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <input
                          type="file"
                          id="nibFile"
                          class="d-none"
                          @change="handleFile('nib_file', $event)"
                        />
                        <label
                          for="nibFile"
                          class="btn btn-outline-secondary mb-0"
                          >Upload File</label
                        >
                      </template>
                    </div>
                  </div>
                  <span
                    v-if="validationErrors.nib_file"
                    class="text-danger small"
                    >Document cannot be empty</span
                  >
                  <div
                    class="d-flex justify-content-between align-items-center px-3 input-form-frame"
                  >
                    <div>
                      <label class="mb-0 font-label">
                        Identitas Pribadi Beneficial Owner<span
                          class="text-danger"
                          >*</span
                        >
                      </label>
                    </div>
                    <div class="d-flex align-items-center">
                      <template
                        v-if="
                          isUploading &&
                          currentUploadingKey === 'beneficial_owner_id'
                        "
                      >
                        <LoadingBar
                          :isLoading="isUploading"
                          :progress="uploadProgress"
                          class="me-2"
                        />
                      </template>
                      <template v-if="fileOwner">
                        <div class="d-flex gap-2 align-items-center">
                          <div class="d-flex gap-2">
                            <img
                              src="/assets/icons/ic_success.png"
                              width="24px"
                              height="24px"
                            />
                            <a :href="fileOwner" target="_blank">{{
                              truncateText(fileOwner)
                            }}</a>
                          </div>

                          <img
                            src="../../../public/assets/trash.png"
                            alt="Delete"
                            class="ms-2 trash-icon"
                            @click="deleteFile('fileOwner')"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <input
                          type="file"
                          id="beneficialOwnerId"
                          class="d-none"
                          @change="handleFile('beneficial_owner_id', $event)"
                        />
                        <label
                          for="beneficialOwnerId"
                          class="btn btn-outline-secondary mb-0"
                          >Upload File</label
                        >
                      </template>
                    </div>
                  </div>
                  <span
                    v-if="validationErrors.beneficial_owner_id"
                    class="text-danger small"
                    >Document cannot be empty</span
                  >
                  <div
                    class="d-flex justify-content-between align-items-center px-3 input-form-frame"
                  >
                    <div>
                      <label class="mb-0 font-label">
                        Surat Kuasa<span class="text-muted text-info-input"
                          >(Opsional)</span
                        >
                      </label>
                    </div>
                    <div class="d-flex align-items-center">
                      <template
                        v-if="
                          isUploading && currentUploadingKey === 'surat_kuasa'
                        "
                      >
                        <LoadingBar
                          :isLoading="isUploading"
                          :progress="uploadProgress"
                          class="me-2"
                        />
                      </template>
                      <template v-if="fileSurat">
                        <div class="d-flex gap-2 align-items-center">
                          <div class="d-flex gap-2">
                            <img
                              src="/assets/icons/ic_success.png"
                              width="24px"
                              height="24px"
                            />
                            <a :href="fileSurat" target="_blank">{{
                              truncateText(fileSurat)
                            }}</a>
                          </div>

                          <img
                            src="../../../public/assets/trash.png"
                            alt="Delete"
                            class="ms-2 trash-icon"
                            @click="deleteFile('fileSurat')"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <input
                          type="file"
                          id="suratKuasa"
                          class="d-none"
                          @change="handleFile('surat_kuasa', $event)"
                        />
                        <label
                          for="suratKuasa"
                          class="btn btn-outline-secondary mb-0"
                          >Upload File</label
                        >
                      </template>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center px-3 input-form-frame"
                  >
                    <div>
                      <label class="mb-0 font-label">
                        Akta Perubahan<span class="text-muted text-info-input"
                          >(if any)</span
                        >
                      </label>
                    </div>
                    <div class="d-flex align-items-center">
                      <template
                        v-if="
                          isUploading &&
                          currentUploadingKey === 'akta_perubahan'
                        "
                      >
                        <LoadingBar
                          :isLoading="isUploading"
                          :progress="uploadProgress"
                          class="me-2"
                        />
                      </template>
                      <template v-if="filePerubahan">
                        <div class="d-flex gap-2 align-items-center">
                          <div class="d-flex gap-2">
                            <img
                              src="/assets/icons/ic_success.png"
                              width="24px"
                              height="24px"
                            />
                            <a :href="filePerubahan" target="_blank">{{
                              truncateText(filePerubahan)
                            }}</a>
                          </div>

                          <img
                            src="../../../public/assets/trash.png"
                            alt="Delete"
                            class="ms-2 trash-icon"
                            @click="deleteFile('filePerubahan')"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <input
                          type="file"
                          id="aktaPerubahan"
                          class="d-none"
                          @change="handleFile('akta_perubahan', $event)"
                        />
                        <label
                          for="aktaPerubahan"
                          class="btn btn-outline-secondary mb-0"
                          >Upload File</label
                        >
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-start mt-4">
                <button
                  class="btn btn-md btn-outline-secondary me-2"
                  @click="$router.push('/company-detail')"
                >
                  Back
                </button>
                <button
                  class="btn btn-md btn-outline-secondary me-2"
                  @click="saveAndQuit"
                >
                  Save & Quit
                </button>
                <button
                  class="btn btn-md btn-primary"
                  @click="showContinueModal"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { onBeforeUnmount, onBeforeMount, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import {
  uploadDocument,
  getDataCompany,
  saveDataCompany,
} from "../../api/company";
import LoadingBar from "../../components/LoadingBar.vue";
import { buildFormData } from "../../utils/param-builder";

export default {
  components: {
    LoadingBar,
  },
  data() {
    return {
      stepNumber: 2,
      merchantId: 0,
      akta_pendirian: "",
      surat_izin_operasional: "",
      nib_file: "",
      direktur_utama_id: "",
      beneficial_owner_id: "",
      surat_kuasa: "",
      akta_perubahan: "",
      documentKey: "",
      documentFile: {},
      fileAkta: "",
      fileSiup: "",
      filenib: "",
      fileDirektur: "",
      fileOwner: "",
      filePerubahan: "",
      fileSurat: "",
      uploadSuccess: {
        akta_pendirian: false,
        surat_izin_operasional: false,
        nib_file: false,
        direktur_utama_id: false,
        beneficial_owner_id: false,
        surat_kuasa: false,
        akta_perubahan: false,
      },
      isUploading: false,
      isLoading: false,
      uploadProgress: 0,
      currentUploadingKey: "",
      validationErrors: {
        akta_pendirian: false,
        surat_izin_operasional: false,
        nib_file: false,
        direktur_utama_id: false,
        beneficial_owner_id: false,
      },
    };
  },
  setup() {
    const store = useStore();
    const body = document.getElementsByTagName("body")[0];
    const route = useRoute();
    const isDocumentCompanyPage = computed(
      () => route.name === "DocumentCompany"
    );

    onBeforeMount(() => {
      const storedEmail = localStorage.getItem("merchant_email");
      const storedToken = localStorage.getItem("auth_token");
      if (storedEmail) {
        store.commit("auth/setEmail", storedEmail);
      }
      if (storedToken) {
        store.commit("auth/setToken", storedToken);
      }
      store.state.hideConfigButton = true;
      store.state.showSidenav = false;
      store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
    });

    onBeforeUnmount(() => {
      store.state.hideConfigButton = false;
      store.state.showSidenav = true;
      store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    });

    return {
      isDocumentCompanyPage,
    };
  },
  methods: {
    async handleFile(key, event) {
      const file = event.target.files[0];
      if (file) {
        const allowedFormats = ["application/pdf", "image/png", "image/jpeg"];
        if (!allowedFormats.includes(file.type)) {
          this.$swal(
            "Validation Error",
            "Only PNG, JPG, PDF files are allowed",
            "warning"
          );
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          this.$swal(
            "Validation Error",
            "File size must not exceed 2MB",
            "warning"
          );
          return;
        }
        this.documentFile[key] = true;

        const formData = new FormData();
        formData.append("merchant_id", this.merchantId);
        formData.append("document_key", key);
        formData.append("document_file", file);

        this.isUploading = true;
        this.currentUploadingKey = key;
        this.uploadProgress = 0;

        try {
          const response = await uploadDocument(formData, (progressEvent) => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          });
          if (response.status === "success") {
            this.uploadSuccess[key] = true;
            this[`file${key.charAt(0).toUpperCase() + key.slice(1)}`] =
              response.data.file_path || response.data.file_url;
            console.log(`File uploaded successfully for ${key}`);
          }
        } catch (error) {
          console.error(`Error uploading file for ${key}:`, error);
          this.uploadSuccess[key] = false;
        } finally {
          this.isUploading = false;
          this.currentUploadingKey = "";
          this.fetchData();
        }
      }
    },
    async fetchData() {
      const response = await getDataCompany(this.merchantId, this.stepNumber);
      if (response.status === "success") {
        this.fileAkta =
          response.data.akta_pendirian_path ?? response.data.akta_pendirian_url;
        this.fileSiup =
          response.data.surat_izin_operasional_path ??
          response.data.surat_izin_operasional_url;
        this.filenib =
          response.data.nib_file_path ?? response.data.nib_file_url;
        this.fileDirektur =
          response.data.direktur_utama_id_path ??
          response.data.direktur_utama_id_url;
        this.fileOwner =
          response.data.beneficial_owner_id_path ??
          response.data.beneficial_owner_id_url;
        this.filePerubahan =
          response.data.akta_perubahan_path ?? response.data.akta_perubahan_url;
        this.fileSurat =
          response.data.surat_kuasa_path ?? response.data.surat_kuasa_url;

        const keys = {
          akta_pendirian: this.fileAkta,
          surat_izin_operasional: this.fileSiup,
          nib_file: this.filenib,
          direktur_utama_id: this.fileDirektur,
          beneficial_owner_id: this.fileOwner,
          surat_kuasa: this.fileSurat,
          akta_perubahan: this.filePerubahan,
        };

        for (const [key, file] of Object.entries(keys)) {
          if (file) {
            this.documentFile[key] = true;
          }
        }
      }
    },
    validateInputs() {
      const requiredKeys = [
        "akta_pendirian",
        "surat_izin_operasional",
        "nib_file",
        "direktur_utama_id",
        "beneficial_owner_id",
      ];

      let isValid = true;

      for (const key of requiredKeys) {
        if (
          !this.documentFile[key] &&
          !this[`file${key.charAt(0).toUpperCase() + key.slice(1)}`]
        ) {
          this.validationErrors[key] = true;
          isValid = false;
        } else {
          this.validationErrors[key] = false;
        }
      }

      return isValid;
    },
    async submitForm(type = "submit") {
      if (!this.validateInputs()) {
        return;
      }

      this.isLoading = true;

      const body = {
        merchant_id: this.merchantId,
        akta_pendirian: this.documentFile.akta_pendirian || this.fileAkta,
        surat_izin_operasional:
          this.documentFile.surat_izin_operasional || this.fileSiup,
        nib_file: this.documentFile.nib_file || this.filenib,
        direktur_utama_id:
          this.documentFile.direktur_utama_id || this.fileDirektur,
        beneficial_owner_id:
          this.documentFile.beneficial_owner_id || this.fileOwner,
        surat_kuasa: this.documentFile.surat_kuasa || this.fileSurat,
        akta_perubahan: this.documentFile.akta_perubahan || this.filePerubahan,
        type: type,
      };

      const formData = buildFormData(body);
      try {
        const response = await saveDataCompany(formData, this.stepNumber);
        return response;
      } catch (error) {
        console.error("Error uploading document:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveAndQuit() {
      if (!this.validateInputs()) {
        return;
      }

      try {
        const response = await this.submitForm("save");
        if (response.status === "success") {
          this.$router.push("/home");
        } else {
          this.$swal("Error", "Error when uploading document", "error");
        }
      } catch (error) {
        console.error("Error in saveAndQuit:", error);
        this.$swal("Error", "An unexpected error occurred", "error");
      }
    },
    async showContinueModal() {
      if (!this.validateInputs()) {
        return;
      }
      try {
        const response = await this.submitForm("submit");
        if (response.status === "success") {
          this.$swal("Success", "Data saved successfully", "success");
          this.$router.push("/company-bank");
        }
      } catch (error) {
        this.$swal("Error", "Error when uploading document", "error");
      }
    },
    deleteFile(key) {
      this[key] = "";
      this.uploadSuccess[key.replace("file", "").toLowerCase()] = false;
    },
    truncateText(text) {
      return text.length > 30 ? text.slice(0, 30) + "..." : text;
    },
  },
  mounted() {
    this.fetchData();
  },
  created() {
    this.merchantId = localStorage.getItem("merchantId");
    this.companyName = localStorage.getItem("merchantName");
  },
};
</script>

<style scoped>
.main-content {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.font-label {
  font-size: 16px;
}

.text-info-input {
  font-size: 8px;
}

.card {
  border-radius: 0.5rem;
}

.card-header {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}

.input-form-frame {
  border: 1px solid #dae0e2;
  border-radius: 20px;
  padding: 16px 4px;
  margin-top: 10px;
}

label {
  white-space: nowrap;
}

.trash-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.input-error {
  border-color: red !important;
}
</style>
